import {
  ApiDimension,
  ApiDimensionCategory,
} from "@incendium/api";
import DimensionSelector from "features/analytics/components/DimensionSelector";
import produce from "immer";
import { IChart } from "Interfaces";
import { useCallback } from "react";

interface IChartBuilderDimensionProps {
  selectedDimension: ApiDimension;
  chart: IChart;
  setChart: React.Dispatch<React.SetStateAction<IChart>>;
  dimensions?: ApiDimension[];
  dimensionCategories?: ApiDimensionCategory[];
  noTooltip?: boolean;
}

function ChartBuilderDimension({
  selectedDimension,
  chart,
  setChart,
  dimensions,
  dimensionCategories,
  noTooltip,
}: IChartBuilderDimensionProps) {
  const onChange = useCallback(
    (e, value) => {
      setChart((chart) =>
        produce(chart, (draft) => {
          const idx = (draft.dimension || []).findIndex(
            (d) => d === selectedDimension
          );
          if (idx >= 0 && draft.dimension) {
            draft.dimension[idx] = value?.dimension || "";
          }
        })
      );
    },
    [setChart, selectedDimension]
  );

  return (
    <DimensionSelector
      dimension={selectedDimension}
      onChange={onChange}
      dimensions={dimensions}
      dimensionCategories={dimensionCategories}
      noTooltip={noTooltip}
    />
  );
}

export default ChartBuilderDimension;
